import React, { useState, useRef } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import busStations from "../../../Data/BusStations.json";
import { RiCalendarLine, RiMapPinLine, RiMapPinFill } from "react-icons/ri";
import styles from "./ModifyBusSearch2.module.css";

const BusCustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <div className={styles.inputWrapper} onClick={onClick}>
    <div className={styles.iconOverlay}><RiCalendarLine /></div>
    <input type="text" className={styles.customInput} value={value} ref={ref} readOnly />
  </div>
));

const ModifyBusSearch2 = ({ searchQuery, onSearch }) => {
  const [fromStation, setFromStation] = useState(searchQuery?.fromStation || "MUMBAI");
  const [toStation, setToStation] = useState(searchQuery?.toStation || "PUNE");
  const [fromStationId, setFromStationId] = useState(searchQuery?.fromStationCode || "");
  const [toStationId, setToStationId] = useState(searchQuery?.toStationCode || "");
  const [travelDate, setTravelDate] = useState(() => {
    if (searchQuery?.travelDate) {
      return moment(searchQuery.travelDate, "YYYY-MM-DD").toDate();
    }
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });
  const [errors, setErrors] = useState({});
  const [fromStationResults, setFromStationResults] = useState([]);
  const [toStationResults, setToStationResults] = useState([]);
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);

  const handleFromStationSearch = (e) => {
    const value = e.target.value;
    setFromStation(value);
    if (value.length > 0) {
      const filteredStations = busStations.stationList
        .filter((station) => station.stationName.toLowerCase().includes(value.toLowerCase()))
        .slice(0, 10);
      setFromStationResults(filteredStations);
    } else {
      setFromStationResults([]);
    }
  };

  const handleToStationSearch = (e) => {
    const value = e.target.value;
    setToStation(value);
    if (value.length > 0) {
      const filteredStations = busStations.stationList
        .filter((station) => station.stationName.toLowerCase().includes(value.toLowerCase()))
        .slice(0, 10);
      setToStationResults(filteredStations);
    } else {
      setToStationResults([]);
    }
  };

  const handleFromStationClick = () => {
    const filteredStations = busStations.stationList.slice(0, 10);
    setFromStationResults(filteredStations);
    fromInputRef.current?.select();
  };

  const handleToStationClick = () => {
    const filteredStations = busStations.stationList.slice(0, 10);
    setToStationResults(filteredStations);
    toInputRef.current?.select();
  };

  const handleFromStationSelect = (station) => {
    setFromStation(station.stationName);
    setFromStationId(station.stationId);
    setFromStationResults([]);
  };

  const handleToStationSelect = (station) => {
    setToStation(station.stationName);
    setToStationId(station.stationId);
    setToStationResults([]);
  };

  const handleTravelDate = (date) => {
    setTravelDate(date);
  };

  const validate = () => {
    let temp = {};
    temp.fromStation = fromStation === "" ? false : true;
    temp.toStation = toStation === "" ? false : true;
    temp.travelDate = travelDate === null ? false : true;
    if (fromStation === toStation) temp.sameStation = false;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (validate()) {
      const newSearchQuery = {
        fromStationCode: fromStationId,
        fromStation: fromStation,
        toStationCode: toStationId,
        toStation: toStation,
        travelDate: moment(travelDate).format("YYYY-MM-DD"),
      };
      onSearch(newSearchQuery);
    }
  };

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchRow}>
        {/* From */}
        <div className={styles.inputGroup}>
          <label className={styles.labelStyle}>Leaving From</label>
          <div className={styles.inputWrapper}>
            <div className={styles.iconOverlay}><RiMapPinLine /></div>
            <input
              className={styles.customInput}
              type="text"
              value={fromStation}
              onChange={handleFromStationSearch}
              onClick={handleFromStationClick}
              ref={fromInputRef}
            />
            {fromStationResults.length > 0 && (
              <ul className={styles.locationList}>
                {fromStationResults.map((s) => (
                  <li className={styles.locationItem} key={s.stationId} onClick={() => handleFromStationSelect(s)}>
                    {s.stationName}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {errors.fromStation === false && <span className={styles.errorText}>Required</span>}
        </div>

        {/* To */}
        <div className={styles.inputGroup}>
          <label className={styles.labelStyle}>Going To</label>
          <div className={styles.inputWrapper}>
            <div className={styles.iconOverlay}><RiMapPinFill /></div>
            <input
              className={styles.customInput}
              type="text"
              value={toStation}
              onChange={handleToStationSearch}
              onClick={handleToStationClick}
              ref={toInputRef}
            />
            {toStationResults.length > 0 && (
              <ul className={styles.locationList}>
                {toStationResults.map((s) => (
                  <li className={styles.locationItem} key={s.stationId} onClick={() => handleToStationSelect(s)}>
                    {s.stationName}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {errors.toStation === false && <span className={styles.errorText}>Required</span>}
        </div>

        {/* Date */}
        <div className={styles.inputGroup} style={{ flex: '0 0 180px' }}>
          <label className={styles.labelStyle}>Date</label>
          <DatePicker
            selected={travelDate}
            onChange={handleTravelDate}
            customInput={<BusCustomDateInput />}
            dateFormat="dd MMM yyyy"
          />
        </div>

        {/* Button */}
        <button type="button" className={styles.searchBtn} onClick={handleSearch}>
          MODIFY SEARCH
        </button>
      </div>
    </div>
  );
};

export default ModifyBusSearch2;